import { fetchAuthenticatedJSON, urlParams } from 'utils/request';

export const cancelAppointment = (appId, date, message = '', cancelSeries = false) => {
  const form = {
    appId,
    message,
    cancelMessage: message,
    sendMessage: '', // the old ui does not send data here
    manageCalendar: sfUser.canManageCalendar(),
    endDate: cancelSeries ? date : '', // Cancel all appointments of this series from date
    cancelSeries
  };
  const URL = "../appointments/cancelAppointment.html";
  return fetchAuthenticatedJSON(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: urlParams(form)
  });
}
